export enum REVIEW_STATUS {
  DONE = 'DONE',
  PENDING = 'PENDING',
  GMB = 'GMB',
  PENDING_GMB = 'PENDING_GMB',
  DONE_GMB = 'DONE_GMB',
}
